import generatePicker from "antd/es/date-picker/generatePicker";
import generateSinglePicker from "antd/es/date-picker/generatePicker/generateSinglePicker";
import dateFnsGenerateConfig from "rc-picker/es/generate/dateFns";

const { RangePicker } = generatePicker<Date>(dateFnsGenerateConfig);
const { DatePicker } = generateSinglePicker<Date>(dateFnsGenerateConfig);
export { RangePicker, DatePicker };
